<nz-affix [nzOffsetTop]="0">
    <div class="bg">
        <div class="top">
            <div class="menus">
                 <img src="../../../assets/images/shouye/logo.png" class="logo-img" style="margin-right: 20px;height: 35px;">
                <!-- <img src="../../../assets/images/logo-pgconf.png" alt="" style="width: 240px;margin-right: 20px;"> -->
                <!-- <span [class]="{'active':thisUrl=='/'}" routerLink="/">返回主页</span> -->
                 <div>
                  <span [class]="{'active':thisUrl=='/'}" (click)="navActive('/')" class="nav-list">首页</span>
                <span [class]="{'active':thisUrl=='/guest'}" (click)="navActive('/guest')" class="nav-list">特邀嘉宾</span>
                <span [class]="{'active':thisUrl=='/agenda'}" (click)="navActive('/agenda')" class="nav-list">大会议程</span>
                <span [class]="{'active':thisUrl=='/video'}" (click)="navActive('/video')" class="nav-list">视频回顾</span>
                <!-- <span [class]="{'active':thisUrl=='/ppt'}" (click)="navActive('/ppt')" class="nav-list">PPT下载</span>   -->
                 <span [class]="{'active':thisUrl=='/connect'}" (click)="navActive('/connect')" class="nav-list">联系我们</span>
                
                 </div>
                 <div>
                    <a style="text-align: right;float: right;margin-right: 20px;display: inline-block;color: #fff;" href="https://ivorysql.io/how2025/" target="_blank">
                      <img src="../../../assets/images/new-en.svg" alt="" style="margin-right: 10px;" width="20px" height="20px">
                      <span>EN</span>
                    </a>
                 </div>
                <!-- <span [class]="{'active':thisUrl=='/sponsor'}" (click)="navActive('/sponsor')">赞助合作</span> -->
                <!-- <span [class]="{'active':thisUrl=='/organizer'}" (click)="navActive('/organizer')">组织者</span> -->
                <!-- <span *ngIf="!isThemeEnd" [class]="{'active':thisUrl=='/theme'}" (click)="navActive('/theme')">提交演讲</span>  -->
                <!-- <a href="https://www.baidu.com" target="_blank" style="margin-left: 20px;"><span>演讲征集</span></a> -->
                <!-- <span [class]="{'active':thisUrl=='/accommodation'}" (click)="navActive('/accommodation')">会议酒店</span> -->
                <!-- <span><a href="../../../assets/html/form.html" target="_blank">参会报名</a></span> -->
                <!-- <span [class]="{'active':thisUrl=='/liveEntry'}">直播入口</span> -->
                <!-- <span><a href="https://2020.postgresconf.cn/photos" target="_blank">大会图库</a></span> -->
                <!-- <span routerLink="/en">EN</span> -->

            </div>
        </div>
    </div>
</nz-affix>
<nz-modal
[(nzVisible)]="isVisibleMiddle"
nzCentered
(nzOnCancel)="handleCancelMiddle()"
(nzOnOk)="handleOkMiddle()"
[nzTitle]="modalTitle"
[nzContent]="modalContent"
[nzFooter]="modalFooter"
>
<ng-template #modalTitle id="sign-modal">

</ng-template>
      <ng-template #modalContent>
        <img src="../../../assets/images/logo-pgconf.png" alt="">
        <div class="big-title" style="font-size: 30px;font-family: Helvetica Neue LT Pro;margin-top: 30px;">参会报名</div>
        <div style="margin-bottom: 20px;">请选择参会方式: </div>
        <div style="text-align: center">
          <button class="b-btn-orange submit-btn" (click)="goUrl('/signup')" style="margin-right: 20px;">线下参会</button>
          <a  (click)="toHref('https://marketing.csdn.net/p/6c7d485dbe5ea7de8e2b0a1f0f967573')" target="_blank"><button class="b-btn-blue submit-btn" (click)="isVisibleMiddle=true" style="border-color: #535353;color: #535353;">线上参会</button></a>
        </div>
      </ng-template>

      <ng-template #modalFooter></ng-template>
</nz-modal>